import React, { useEffect, useState } from "react";
import Button from "../modules/Button";
import rightImg from "../../Assets/svg/form image.svg";
import DropBtn from "../modules/DropBtn";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import "./welcome.scss";
import FooterText from "../modules/FooterText";
import { addStatusInfo, addStatusList, resetStatus } from "./redux/actions";
import { api } from "../../Services";
import { addTokenInfo, doLogout } from "../LoginPage/redux/actions";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";

function WelcomeBack() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);

  const [percentage, setPercentage] = useState(0);
  const status = useSelector((state) => state.status.statusData);
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const education = useSelector((state) => state.education.eduInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const [incomeList, setIncomeList] = useState({
    Father: "fatherIncomeCertificate",
    Mother: "motherIncomeCertificate",
    Sibling1: "sibling1IncomeCertificate",
    Sibling2: "sibling2IncomeCertificate",
    Sibling3: "sibling3IncomeCertificate",
    Guardian: "guardianIncomeCertificate",
    Myself: "incomeCertificate",
    "No-one": "noIncomeCertificate",
  });
  const [Link, setLink] = useState("");
  const [allTotal, setAllTotal] = useState({
    personal: "",
    edu: "",
    income: "",
    total: "",
  });
  const nextField = () => {
    let url = GetBaseUrl(window.location.href);
    //window.location.replace(url + "/application/form");
    navigate("/application/form");
  };

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const submitPan = async (name, dob, value) => {
    try {
      let panInfo = { panNumber: value, name: name, dob: dob };

      let res = await await api.verifyPan(panInfo, tokenData.token);
      // let pL = { ...panList };
      if (res.statusCode !== 200 && res.data.includes("Session expired")) {
        logoutMsg();
      }
      return res;
    } catch (error) {
      console.error("Error Validating PAN:", error);
      if (error?.data?.includes("Session expired")) {
        logoutMsg();
      }
    }
  };

  const verifyPan = async (name, dob, value) => {
    let type = false;
    try {
      setUploading(true);
      let res = await await submitPan(name, dob, value);
      if (res?.data?.panStatusCode === "E") {
        setUploading(false);
        type = true;
      }
      return type;
    } catch (error) {
      setUploading(false);
      console.error("Error Validating PAN:", error);
      return false;
    } finally {
      setUploading(false);

      return type;
    }
  };

  const getPersonal = (personal, docData) => {
    let count = 0;
    let total = 0;
    let countList = [];
    let totalList = [];
    for (let i in personal) {
      if (i === "address") {
        let address = personal[i].filter(
          (a) => a.addressType === "TEMPORARY"
        )[0];
        for (let j in address) {
          if (
            // address[j] &&
            j !== "addressType" &&
            j !== "salesForceAddressId" &&
            j !== "id"
          ) {
            let perm = personalInfo.address.filter(
              (a) => a.addressType === "PERMANENT"
            )[0];
            if (address?.pin === "" || address?.pin !== perm?.pin) {
              total += 1;
              totalList = [...totalList, j];
              if (j === "addressProof") {
                console.log("personal addressProof", docs, address, personal);

                if (docData && docData[`currentAddressProof`]?.name) {
                  count += 1;
                  countList = [...countList, j];
                }
                // }
              } else if (address[j]) {
                console.log("personal", j, personal);
                count += 1;
                countList = [...countList, j];
              }
            }
            // count += 1;
          }
        }
      } else if (
        i === "BirthCertificate" ||
        i === "dob" ||
        i === "email" ||
        i === "experience" ||
        i === "firstName" ||
        i === "gender" ||
        i === "mobile" ||
        i === "photo"
      ) {
        if (i === "mobile") {
          if (personal[i]?.length === 10) {
            count += 1;
            countList = [...countList, i];
          }

          total += 1;
          totalList = [...totalList, i];

          console.log("personal ", i, personal);
        } else if (i === "email") {
          const pinRegex =
            /^([a-zA-Z0-9._-]+)@([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,4})$/;
          console.log("id", !pinRegex.test(personal[i]?.trim()));
          // isError = !pinRegex.test(personal[i]);
          if (pinRegex.test(personal[i]?.trim())) {
            count += 1;
            countList = [...countList, i];
          }

          total += 1;
          totalList = [...totalList, i];

          console.log("personal", i, personal);
        } else if (i === "photo") {
          // isError = !pinRegex.test(personal[i]);
          if (docData &&  docData?.profilePicture) {
            count += 1;
            countList = [...countList, i];
          }

          total += 1;
          totalList = [...totalList, i];

          console.log("personal ", i, docs);
        } else if (i === "BirthCertificate") {
          // isError = !pinRegex.test(personal[i]);
          if (docData && docData?.BirthCertificate?.name) {
            count += 1;
            countList = [...countList, i];
          }

          total += 1;
          totalList = [...totalList, i];

          console.log("personal ", i, docs);
        } else {
          if (personal[i]) {
            count += 1;
            countList = [...countList, i];
          }
          total += 1;
          totalList = [...totalList, i];

          console.log("personal ", i, personal);
        }
      }
    }
    console.log(
      "in personal",
      count,
      total,
      count / total,
      personal,
      countList,
      totalList
    );
    let remElements = [];
    totalList.forEach((number) => {
      if (!countList.includes(number)) {
        remElements = [...remElements, number];
      }
    });
    let detailsList = { count: countList, total: totalList, rest: remElements };
    let finalpercentage = Math.floor(Math.abs(count / total) * 100);
    setAllTotal({ ...allTotal, personal: finalpercentage });

    dispatch(
      addStatusInfo(["personal", Math.floor(Math.abs((count / total) * 100))])
    );
    dispatch(addStatusList(["personalList", detailsList]));
  };
  const getIncome = (income, docData) => {
    let count = 0;
    let total = 0;
    let countList = [];
    let totalList = [];
    let list = income["membersList"];
    for (let i in list) {
      if (list[i]?.relationShipType !== "No-one") {
        for (let j in list[i]) {
          if (
            j === "dob" ||
            j === "doc" ||
            j === "firstName" ||
            j === "income" ||
            j === "mobile" ||
            j === "occupation" ||
            j === "pan"
          ) {
            if (j === "mobile" || j === "pan") {
              console.log("income ", j, list[i]);

              if (j === "mobile" && list[i][j]?.length === 10) {
                count += 1;
                countList = [...countList, j];
              } else if (
                j === "pan" &&
                list[i][j]?.length === 10 &&
                verifyPan(list[i]["firstName"], list[i]["dob"], list[i]["pan"])
                // panList[list[i]?.relationShipType]
              ) {
                count += 1;
                countList = [...countList, j];
                console.log("income ", j, list[i]);
              }
            } else if (j === "doc") {
              if (docData && docData[incomeList[list[i]?.relationShipType]]) {
                count += 1;
                countList = [...countList, j];
              }
              console.log("income ", j, docs);
            } else if (list[i][j]) {
              count += 1;
              countList = [...countList, j];
            }
            total += 1;
            totalList = [...totalList, j];
            console.log("income ", j, docs);
          }
        }
      } else if (list[i]?.relationShipType === "No-one") {
        total = 1;
        if (docData && docData[incomeList[list[i]?.relationShipType]]) {
          count += 1;
        }
      }
    }
    let totalDivide;
    if (count === 0 && total === 0) {
      totalDivide = 0;
    } else if (count === 0) {
      totalDivide = 0;
    } else {
      totalDivide = count / total;
    }
    let finalpercentage = Math.floor(Math.abs(totalDivide * 100).toFixed(2));

    console.log(
      "in btn income",
      count,
      total,
      totalDivide,
      countList,
      totalList
    );
    setAllTotal({ ...allTotal, income: finalpercentage });
    let remElements = [];
    totalList.forEach((number) => {
      if (!countList.includes(number)) {
        remElements = [...remElements, number];
      }
    });
    let detailsList = { count: countList, total: totalList, rest: remElements };

    dispatch(
      addStatusInfo([
        "income",
        Math.floor(Math.abs(totalDivide * 100).toFixed(2)),
      ])
    );
    dispatch(addStatusList(["incomeList", detailsList]));
  };

  const getEdu = (edu, docData) => {
    let count = 0;
    let total = 0;
    let list = edu;
    let totalList = [];
    let countList = [];
    console.log("list edu", list);
    for (let i in list) {
      if (
        i === "admissionLetter" ||
        i === "campusSpecific" ||
        // i === "campus" ||
        i === "city" ||
        i === "fee" ||
        i === "paymentReciept" ||
        i === "paymentReceipt"
      ) {
        total += 1;
        totalList = [...totalList, i];
        if (
          i === "admissionLetter" ||
          i === "paymentReciept" ||
          i === "paymentReceipt"
        ) {
          console.log("docs in conditiion", docData);
          if (i === "paymentReciept" || i === "paymentReceipt") {
            if (
              docData &&
              (docData?.paymentReciept || docData?.paymentReceipt)
            ) {
              count += 1;
              countList = [...countList, i];
            }
            console.log("edu ", i, docData);
          } else if (docData && docData[i]) {
            count += 1;
            countList = [...countList, i];
            console.log("edu ", i, docData);
          }
          // } else if (
          //   i === "campus" &&
          //   list["campusSpecific"] === "Others" &&
          //   list["campus"]
          // ) {
          //   count += 1;
        } else if (list[i]) {
          count += 1;
          countList = [...countList, i];
          console.log("edu ", i, edu);
        }
      }
    }
    let finalpercentage = Math.floor(Math.abs(count / total) * 100).toFixed(2);

    setAllTotal({ ...allTotal, edu: finalpercentage });
    let remElements = [];
    totalList.forEach((number) => {
      if (!countList.includes(number)) {
        remElements = [...remElements, number];
      }
    });
    let detailsList = { count: countList, total: totalList, rest: remElements };

    console.log(
      "in btn education",
      count,
      total,
      count / total,
      list,
      countList,
      totalList
    );
    dispatch(
      addStatusInfo(["education", Math.floor(Math.abs(count / total) * 100)])
    );
    dispatch(addStatusList(["eduList", detailsList]));
  };
  const callDocs = async () => {
    try {
      const docsData = await api.getDocuments(
        "application",
        tokenData.appId,
        tokenData.token
      );
      if (docsData.statusCode !== 200 && docsData.data.includes("Session expired")) {
        logoutMsg();
      }
      return docsData;
    } catch (err) {
      console.log("err", err.data);
      if (err?.data?.includes("Session expired")) {
        logoutMsg();
      }
    }
  };
  const getDocs = async () => {
    try {
      setUploading(true);
      const docsData = await callDocs();
      if (docsData?.data) {
        console.log(JSON.stringify(docsData));
        dispatch(addTokenInfo(["docs", docsData.data]));
        getPercentage(docsData.data);
        setUploading(false);
      }
    } catch (err) {
      setUploading(false);

      console.log("err", err.data);
    }finally{
      setUploading(false)
    }
  };
  const getPercentage = (docData) => {
    getPersonal(personalInfo, docData);
    getEdu(education, docData);
    getIncome(incomeInfo, docData);
    // console.log('percentage status',status)

    let total = status.personal + status.education + status.income;
    console.log("total", total);
    if (total > 0) {
      total = Math.floor(total / 3);
      console.log("total is not 0", total);
    }
    if (total % 1 === 0) {
      setPercentage(total);
    } else {
      setPercentage(0);
    }
  };
  useEffect(() => {
    getDocs();
  }, []);
  useEffect(() => {
    let url = window.location.href;
    let baseUrl = GetBaseUrl(url);

    const cleanedUrl = url.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);
    if (tokenData.applicationStatus !== "Registered") {
      // window.location.replace(baseUrl + "/application/submitted-status");
      navigate("/application/submitted-status");
    }
  }, []);
  useEffect(() => {
    if (percentage < 1 || percentage === 28) {
      getPercentage(docs);
    }
  }, [percentage]);

  return (
    <div className="form-div welcome-page">
      <div className="form-title">Welcome back!</div>
      <div className="content">
        <div className="content-left  content-item">
          <div className="left-title">Continue your Application</div>
          <div className="instructions" style={{ color: "transparent" }}>
            Alert! Deadline for this year's submission is April 4, 2024.
          </div>

          <div className="chart-div">
            <div className="text-div">
              <CircularProgressbar value={percentage} text={`${percentage}%`} />
              <div className="status">completed</div>
            </div>
          </div>
        </div>
        <Button
          onClickHandler={() => nextField()}
          type={"contained"}
          value={"Continue Application"}
        />
      </div>
      <FooterText />
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default WelcomeBack;
